const porChave = (itens, valor) =>
  new Map((itens || []).map((item) => [item.key, valor(item)]));

export const serieDoGraficoDaV2 = ({ receita, conversao, atencao }) => {
  const grupos = receita?.groups || [];
  const labels = grupos.map((grupo) => grupo.key);
  const conversaoPorChave = porChave(
    conversao?.branches?.[0]?.buckets,
    (balde) => balde.conversao_pct
  );
  return {
    labels,
    faturamento: grupos.map((grupo) => grupo.bruto_vendas ?? 0),
    conversao: labels.map((chave) => conversaoPorChave.get(chave) ?? 0),
    exposicao: (atencao?.branches?.[0]?.groups || []).map((grupo) => ({
      date: grupo.key,
      occupation: grupo.pessoa_minuto,
    })),
  };
};

export const filtrosDaAtencao = (filtros) =>
  filtros?.zone_id?.length ? { zone_id: filtros.zone_id } : {};
